import { render, staticRenderFns } from "./AzSubTitle.vue?vue&type=template&id=b3ea735c&scoped=true&"
import script from "./AzSubTitle.vue?vue&type=script&lang=js&"
export * from "./AzSubTitle.vue?vue&type=script&lang=js&"
import style0 from "./AzSubTitle.vue?vue&type=style&index=0&id=b3ea735c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ea735c",
  null
  
)

export default component.exports